import type { IconData } from '@stacksjs/iconify-core'

export const transfer: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m356.687 228.687l22.626 22.626L494.627 136L379.313 20.687l-22.626 22.626L433.372 120H16v32h417.372zM496 360H78.628l76.685-76.687l-22.626-22.626L17.373 376l115.314 115.313l22.626-22.626L78.628 392H496z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default transfer
